import { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AdminAttendance from "./components/AdminAttendance";
import Attendance from "./components/Attendance";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import Reports from "./components/Reports";
import Schedule from "./components/Schedule";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role"));

  // Listen for localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem("token"));
      setRole(localStorage.getItem("role"));
    };

    window.addEventListener("storage", handleStorageChange);
    
    // Also check every 100ms (for changes within same tab)
    const interval = setInterval(() => {
      const newToken = localStorage.getItem("token");
      const newRole = localStorage.getItem("role");
      if (newToken !== token) setToken(newToken);
      if (newRole !== role) setRole(newRole);
    }, 100);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, [token, role]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public route: login - ALWAYS SHOWS LOGIN PAGE FIRST */}
        <Route path="/" element={<Login />} />

        {/* Admin routes */}
        <Route
          path="/dashboard"
          element={token && role === "admin" ? <Dashboard /> : <Navigate to="/" replace />}
        />
        <Route
          path="/admin-attendance"
          element={token && role === "admin" ? <AdminAttendance /> : <Navigate to="/" replace />}
        />
        <Route
          path="/schedule"
          element={token && role === "admin" ? <Schedule /> : <Navigate to="/" replace />}
        />
        <Route
          path="/reports"
          element={token && role === "admin" ? <Reports /> : <Navigate to="/" replace />}
        />

        {/* Staff route */}
        <Route
          path="/staff-attendance"
          element={token && role === "staff" ? <Attendance /> : <Navigate to="/" replace />}
        />

        {/* Catch-all - redirect to home (login) */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;